import React, { KeyboardEventHandler, ReactNode } from 'react';

/**
 * This is a wrapper component for custom Contextual menu's subMenuProps items.
 * When custom sub menu is open, in case of arrow navigation,
 * we will not propagate event to Contextual menu so that sub menu will
 * not accidentally close
 * Ticket: KB-5953
 */

interface IProps {
  children: ReactNode;
}

const keyboardNavigationCodes = [
  'ArrowUp',
  'ArrowRight',
  'ArrowDown',
  'ArrowLeft',
];

export default ({ children }: IProps) => {
  const handleStopPropagation: KeyboardEventHandler<HTMLDivElement> = (
    event,
  ) => {
    if (keyboardNavigationCodes.includes(event.code)) {
      event.stopPropagation();
    }
  };

  return <div onKeyDown={handleStopPropagation}>{children}</div>;
};
